module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Chapter One")])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("“H")])])])]), _vm._v("ow do I look? Fine enough to serve dinner guests?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lifting her arms away from her body, Angela Malone turned on the heel of her sandal in front of the Sandbur cook, then dropped a playful curtsy.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hmm,” Cook said, as she thoughtfully surveyed her young helper. “If you took off the apron you’d look like a princess in that little black dress. But since we’re serving barbecue tonight, you might ought to keep it on.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Angela was inclined to agree. The little black dress was just a simple cotton sheath, but in spite of her having worked as a waitress at The Cattle Call Café for the past two years, she wasn’t always the most graceful. There had been times gravy and sauces had landed on her instead of on the table she was serving. But that was then. She’d moved up in life since her friend Nicci Saddler Garroway had gotten her this job on the Sandbur Ranch in south Texas. Now she was Cook’s kitchen assistant in the “big house” where the matriarch Geraldine Saddler and her son, Lex, resided. Besides helping Cook prepare and serve meals, Angela also oversaw the maids’ housecleaning, shopped for both households and generally took care of any leftover task that the maids couldn’t deal with.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You’re probably right about the apron, Cook,” Angela told the woman. “But I do want Ms. Saddler to think I look presentable. She really seems to want to put on the dog tonight.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Cook, a tall, thin woman in her seventies with hair that was more black than gray and lips painted as deep a red as her fingernails, walked over to where Angela was about to pick up a tray of appetizers.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Don’t be nervous, honey. You’ve served many a table before.” Reaching up, she adjusted the tortoise-shell barrette that was holding the front of Angela’s heavy, brown hair off her face, then patted her cheek. “Pretty as a June mornin’. Now shoo. Go on with those appetizers before Geraldine comes back here to see why we’re dawdlin’.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Grinning, Angela picked up the tray. “I’m on my way!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Shouldering her way through the kitchen’s swinging door, Angela hurried down the long hallway that would lead her to the formal living room. Along the way, the smell of smoked shrimp, brought fresh from San Antonio Bay only the previous day, wafted up to her nose, reminding her that she’d not taken time to eat since breakfast at five that morning.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("With a dinner party scheduled, she’d not had time to do anything, except help Cook prepare a whole table of elaborate dishes and make sure the maids had cleaned all the rooms and arranged fresh flowers.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As Angela neared the opening of the living room, she caught the sound of voices, both male and female, intermixed with light laughter. In the background, a CD of Bob Wills and his Texas Playboys was softly playing a waltz.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("One, two, three. One, two, three, she silently hummed to the beat. How lovely it would be to be dancing, waltzing in the arms of some nice guy who didn’t care that she was a single mother.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Pushing that wishful thought away, Angela took a deep breath and stepped into the living room. One quick glance from the corner of her eye told her the space was full of people.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Careful to skirt the crowd, many of whom were standing about the room in small groups, Angela headed straight to a long table that had been set up near the wet bar. She was about to place the tray of shrimp next to a platter of fried jalapeños when Geraldine Saddler spoke up from behind her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Angie, if that’s the shrimp, bring it over here, please. There’s plenty of space on the coffee table.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Turning quickly to follow the woman’s orders, Angela made her way to the middle of the room where a chesterfield couch and matching armchairs were grouped around a low coffee table.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As she carefully placed the tray on the polished oak, Geraldine spoke behind her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You should try these, Jubal. They’ll melt in your mouth.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Angela momentarily froze. Surely it wasn’t "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("him!")])]), _vm._v(" He couldn’t be the new veterinarian for the Sandbur, the reason for this party, she thought wildly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her heart thudding with heavy dread, she slowly raised her head and found herself staring into the face that she’d spent the past five years desperately trying to forget.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Jubal. She didn’t know whether she whispered the name, mouthed it with her lips or silently shouted it. In any case, she could feel the blood draining from her face, hear a loud rushing noise in her ears.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She watched a flicker of recognition, then shock, cross his face, but she didn’t wait around to see if he would actually acknowledge her. She excused herself to Geraldine, then practically raced from the room.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("By the time she got back to the kitchen, she was out of breath and her legs were so weak that all she could do was slump onto a bench seat.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Seeing Angela’s shaky entrance, Cook dropped a pair of tongs and hurried over to her. “Angie, what’s wrong, girl? You look like you’re gonna be sick!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Gulping in breaths of air, Angela wiped at the sweat that had popped out suddenly on her brow and upper lip. “I—I’m okay, Cook. I think—I’ve gone too long without eating.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("That was true enough, Angela thought, as Cook stood with her hands on her hips, her black eyes full of concern.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hmmp. Well, it’s funny to me that you just now remembered you were starving.” Her red lips puckered into a frown. “What happened in there?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("There was no need for Cook to explain that “in there” meant the living room where "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("he")])]), _vm._v(" had been sitting with the Sandbur families and their friends.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Nothing.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Did you spill the tray? Trip over somebody?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She’d tripped all right, and fallen. But that had happened five years ago, she thought miserably.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Everything is—okay, Cook. I just feel shaky.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Closing her eyes, Angela tried to tamp down the panic racing through her. How could she go back in there and serve five courses around a table where he’d be sitting, she wondered frantically.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Here. Eat some of this while I get the salads ready,” Cook ordered. “Maybe that’ll put some color in your cheeks.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Angela opened her eyes to see the old woman placing a small plate filled with Texas caviar and several saltine crackers in front of her. Her throat was so tight, she wasn’t sure she could swallow anything, but she forced herself to shovel up some of the mixture of black-eyed peas, onions and peppers on one of the crackers and pop it into her mouth.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("After a few more bites of the spicy vegetables, Angela rose to her feet and joined Cook at the long counter. The woman needed her, and now was hardly the time for Angela to allow her emotions to immobilize her. “I’ll finish this,” she assured the woman. “You go ahead with whatever you need to be doing.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Cook frowned as she glanced at Angela’s still-pale face. “You look like you’ve fallen in a flour barrel. Maybe I’d better call Miss Nicci back here to check on you. Even young people have heart attacks.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her heart was full of pain, all right. But not the sort that Cook was worried about. “You’re not about to bother Nicci this evening! Her off-duty time is always being interrupted with medical emergencies. I’m not going to ruin this dinner party for her.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Angie—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Before Cook could protest, Angela placed a reassuring hand on her arm. “Cook, don’t worry about me. I—I don’t have anything medically wrong with me.” Deciding it would be easier to confide in Cook than to hide the truth, she added, “I just—saw someone at the party. Someone I haven’t seen in a long time. And I—well, I never expected to see him again. Ever. It was shocking to me. That’s all.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Instead of plying her with personal questions, Cook tactfully asked, “You want me to call Alida over to take your place tonight?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Alida was one of the maids that had worked for the Saddler and Sanchez families for several years. At the moment she was at Angela’s house, babysitting Angela’s daughter, Melanie, and as far as Angela was concerned, that was where she was going to stay.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Straightening her shoulders, Angela set her jaw with determination. “No. I’ll be fine. Just fine.”")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span')]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Out in the living room, Jubal Jamison struggled to focus on the conversation going on around him. Seeing Angie again had shaken the very earth beneath him. Dear God, he’d never expected to see her beautiful face again. Not after she’d left Cuero five years ago. What was she doing here? Obviously she was employed by the ranch, although no one had bothered to tell him. But then why would they, he thought grimly. No one on the Sandbur knew that Angela had once been the love of his life.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("So what are you going to do now, big boy? Run? Turn away from her again?")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Not this time, Jubal silently swore. After she’d left town, he believed he’d never be given the chance to see Angie again. He wasn’t about to pass up this opportunity to connect with her once more. Besides, he’d already moved onto the Sandbur. An animal clinic was currently being constructed smack in the middle of the ranch yard. Costly high-tech equipment, being shipped from Dallas, was scheduled to arrive any day.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Someone announced that dinner was ready and like a zombie Jubal shuffled along to the dining room with the rest of the guests. Moments later he found himself seated to the right of Geraldine Saddler at the head of the dinner table.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The room was long, the ceiling low and crossed with rough-hewn beams of cypress wood. Along one wall, a row of arched windows displayed a view of the backyard where the trunks of Mexican palms were decorated with tiny, clear lights, signifying the coming holidays. Back at the long table, fresh gold and red flowers were arranged at intervals down the center, adding even more vivid color to the scene.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Jubal had grown up in an affluent home, but he had to admit his parents’ social events were modest compared to this Sandbur affair. Even so, Geraldine and her family were very down-home, laid-back people. Too bad his parents couldn’t have been more like them. Maybe then they could have understood his relationship with Angie. But then, his parents weren’t responsible for their separation. Unfortunately, he’d been the guilty party. And he’d been paying the price ever since.")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span')]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("By the time Angela had served after-dinner coffee, she’d worked herself up to a numb fury. Throughout the meal, Jubal had ignored her. He’d not even had the decency to give her a simple hello. It wasn’t like that icky wife of his had been sitting by his side, watching his every move. A polite greeting from him was all she’d expected. But he’d not even been enough of a gentleman to give her that much.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Damn the man,” she muttered under her breath as she stomped back to the kitchen.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“They’re digging into dessert right now,” Angela said to Cook, who was sitting at a long, pine table, her thin, bony hands wrapped around a coffee cup. In her early seventies, the woman should have looked exhausted. Instead, she looked contented.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“There’ll be some more visiting done before the guests leave, but you don’t need to wait around. Go on home to your little girl. I’ll see that the maids get everything cleared away.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Frowning, Angela eased onto the bench seat directly across from Cook. “I’m not about to leave this mess with you. And why are you looking so happy? Aren’t you tired?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The woman chuckled. “’Course I’m tired. But it always makes me happy to put out a good feed for Geraldine’s friends. Those fancy cooks on TV couldn’t have done it better.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You’re proud of your job,” Angela said, then added wistfully, “I wish—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When she stopped abruptly, Cook prompted, “What, child, what do you wish?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Angela sighed. “I wish that my mother could have been more like you, Cook. In the little town where I used to live, Mom worked as a cook in a restaurant. She always griped about the job and said that cooking was poor folks’ work. But nothing much made her happy anyway.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Humph,” Cook snorted. “She must have needed some head doctoring. I feel just as good as anybody out there.” She inclined her dark head in the direction of the living room where the party was still going strong.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“So do I,” Angela agreed. As for Nadine Malone, Angela didn’t know whether her mother was still cooking in the Mustang Café or if her parents even still lived on their farm near Cuero. She’d not seen them since they’d labeled her as worthless and kicked her out of the family home.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Sighing, Angela rose to her feet and walked over to the row of cluttered cabinets. Seeing Jubal tonight was bad enough without her dwelling on her parents, who’d turned their backs on their daughter at the time when she’d needed them the most.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A half hour later, the two women had the kitchen organized enough to call it a night. Angela exited the back of the house carrying a box full of leftovers, enough for two or three suppers for her and Melanie.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("In the backyard, she walked along a path lit with footlights until she reached the far western side of the house where she’d parked her little economy car beneath a live-oak. She was carefully placing the box of food on the back floorboard when she heard the faint crunch of gravel directly behind her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Glancing over her shoulder, she saw Jubal. Alone. And walking directly toward her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Hating the way her heart was pounding, Angela shut the door, then turned to face him. The man had hurt her in ways she didn’t want to think about. All she should be feeling at this moment was intense hatred. But try as she might, she couldn’t hate him. After all, he’d given her the most precious gift a man could give a woman. His child.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hello, Angie.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("There was only a small filtering of light slanting from the big house to the spot where they were standing. She could barely make out his face, but that didn’t matter. She’d not forgotten the shape of his rough, hawkish features, the gold flecks in his green eyes, the thick tumble of sandy-brown hair falling across a wide forehead. His face was too striking to ever forget.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She swallowed. “Hello, Jubal.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His hands were casually stuffed in the pockets of his western-cut trousers and, as her eyes flicked up and down the long length of him, she realized his body had remained fit the past five years. His shoulders were still broad, his thighs muscular, his waist just as trim as the day she’d first seen him, squatted on his heels, doctoring her father’s sick goat.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("After a long silence between them, he spoke again, “I’ve been waiting a few minutes in hopes of catching you. I didn’t get a chance to speak to you inside.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Hurt and anger swirled together and simmered in the pit of her stomach. “I served five courses. Guess I wasn’t around the table long enough for you to look up and say hello.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He let out a long breath and wiped a hand over his face. She could see his discomfort. See that he didn’t know how to deal with her presence. Well, she couldn’t feel sorry for the man. He’d made his bed and she hoped he’d been miserable in it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Looks like you’re not going to cut me any slack, are you?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Why should I?” she quickly countered.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He looked toward the big house, then wearily pinched the bridge of his nose. “All right, I deserve that. And I’m sorry I didn’t say anything to you sooner.” He looked at her. “But seeing you—damn it, I was shocked. What are you doing here on the Sandbur? I never expected to see you in a place like this.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her nostrils flared as she tried to hold on to her temper. What the hell did he think she was doing? Serving a dinner party just for the fun of it?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m working. What are you doing? Rubbing elbows with the rich?” Instantly, she plopped a hand over her mouth in feigned regret. “Oh, sorry. I forgot—you are the rich.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Frowning, he stepped closer as his gaze swallowed up her pale face. “I expected you to throw some cutting things at me, Angie, but not that.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The last he said with a hint of regret and a glaze of tears was suddenly started burning the back of Angela’s eyes. She wasn’t a vengeful, vindictive person. So why was she behaving this way to Jubal?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m not a girl anymore, Jubal. I’m a woman. And I guess things—people—look different to me now.” Which was true enough, she thought. When she’d been dating Jubal she’d been a happy, loving, carefree person. There hadn’t been a bitter bone in her body—until he’d decided to end their relationship and run to another woman. Now she was cautious about putting her trust in anyone.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Drawing his hands out of his pockets, he folded his arms against his chest. Angela’s gaze zeroed in on his left hand where it curved around his right elbow. Not for the first time tonight, she noticed his wedding-ring finger was empty. Again, she was reminded that Evette hadn’t been by his side tonight. She could only speculate on the woman’s whereabouts. This was a big night for Jubal. Angela couldn’t imagine the socialite not wanting to share the spotlight with her spouse.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I had no idea that you were here on the Sandbur,” he admitted. “If I’d known—well, I would have looked you up before now.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Five years had passed and she’d not heard a word from him. Until tonight, when happenstance had forced him to see her. She found it difficult to believe that he would have sought her out.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Pain crept through her chest, while sarcasm edged her one word question. “Really?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("From the grimace on his face, he obviously considered her presence on the ranch a nuisance. Well, she could tell him that having him around wasn’t exactly making her want to shout hallelujah, either.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m not quite the bastard you think, Angie.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("There was no malice or anger in his voice, but then, he had no reason to be spiteful, she thought as she struggled to keep from breaking into sobs. He’d gotten what he wanted.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I came to work here two months ago,” she said hoarsely. “A few days after I’d been on the job, I heard through the grapevine about the ranch hiring a resident vet. I didn’t know—until tonight—that it was you. But don’t worry, Jubal, I’m not going to give you or your family any problems by trying to stir up old ashes.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He looked uncomfortably down at his boots. “I…wasn’t exactly worried about that.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When he didn’t add more, Angela decided to plunge ahead. After all, she didn’t expect that they would be speaking to each other again. His work here would hardly cause them to brush elbows.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“So—where’s Evette? Didn’t she want to come to your party tonight?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His gaze lifted to hers and something in his expression made her heart leap.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m not married to Evette anymore.”")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-746b3cdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/christmasshealwayswantedthe_ch01.vue
// module id = 78
// module chunks = 0